import { useNavigate } from "react-router";

import { AddProgramComponentDialog } from "@/components/pages_logged_in/program/components/AddProgramComponentDialog";
import { CloseProgramComponentDialog } from "@/components/pages_logged_in/program/components/CloseProgramComponentDialog";
import { COMPONENT_DETAILS_PATHS } from "@/components/pages_logged_in/program/components/component-utils";
import { DeleteProgramComponentDialog } from "@/components/pages_logged_in/program/components/DeleteProgramComponentDialog";
import { ProgramStatus } from "@/graphql";
import {
  ComponentDialog,
  LeadComponent,
  MainComponent,
  ParticipantComponent,
} from "@/types/programs";

type Component = MainComponent | LeadComponent | ParticipantComponent;

interface Program {
  id: string;
  status?: ProgramStatus | null;
  targetLaunchDate?: string | null;
}

interface ProgramDashboardDialogsProps {
  program: Program;
  selectedComponent?: Component;
  dialog?: ComponentDialog;
  onCloseDialog: (newComponentId?: string) => void;
}

export function ProgramDashboardDialogs({
  program,
  selectedComponent,
  dialog,
  onCloseDialog,
}: ProgramDashboardDialogsProps) {
  const navigate = useNavigate();

  return (
    <>
      <AddProgramComponentDialog
        componentId={selectedComponent?.id}
        programId={program.id}
        programStatus={program.status}
        targetLaunchDate={program.targetLaunchDate}
        open={dialog === "add-component" || dialog === "edit-component"}
        onClose={onCloseDialog}
      />
      {selectedComponent && (
        <>
          <DeleteProgramComponentDialog
            component={selectedComponent}
            programId={program.id}
            open={dialog === "delete-component"}
            onClose={onCloseDialog}
          />
          <CloseProgramComponentDialog
            component={selectedComponent}
            programId={program.id}
            open={dialog === "close-component"}
            onClose={onCloseDialog}
            onCloseComponent={() => {
              if (
                selectedComponent.id &&
                program.id &&
                selectedComponent.type
              ) {
                const path = COMPONENT_DETAILS_PATHS[selectedComponent.type];
                navigate(
                  `/programs/${program.id}/${path}/${selectedComponent.id}`,
                );
              }
            }}
          />
        </>
      )}
    </>
  );
}
